import React from "react";
import ChartNoData from "../ChartNoData";
import "./styles.scss";

/**
 * HomeTable Component - Compact table for the homepage cards, the first column is the row label
 *
 * @param {Array} columns - Column definitions: { key, title, width, align, render }.
 *   `render(row)` returns the cell content, by default `row[key]` is shown
 * @param {Array} rows - Rows to show, every row needs a unique `key`
 * @param {boolean} loading - Data is still loading, hides the empty message
 * @param {string} emptyMessage - Message shown when there are no rows
 */
const HomeTable = ({ columns, rows = [], loading = false, emptyMessage }) => {
  if (rows.length === 0) {
    return <ChartNoData show={!loading} message={emptyMessage} />;
  }

  return (
    <table className="home-table">
      <thead>
        <tr>
          {columns.map(({ key, title, width, align = "left" }) => (
            <th key={key} className={`home-table-align-${align}`} style={{ width }}>
              {title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.key}>
            {columns.map(({ key, align = "left", render }) => {
              const content = render ? render(row) : row[key];

              // Long texts are cut off, the title shows the full text on hover
              return (
                <td
                  key={key}
                  className={`home-table-align-${align}`}
                  title={typeof content === "string" ? content : undefined}
                >
                  {content}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default HomeTable;
